import request from '@/config/axios'

export interface CatalogServiceVO {
  id?: number
  categoryId?: number
  categoryName?: string
  flowModel?: string
  priceType?: string
  payType?: string
  cancelRules?: string
  specialRules?: string
  templatePackCode?: string
  name?: string
  coverImages?: string
  description?: string
  basePrice?: number
  memberPrice?: number
  specs?: string
  addons?: string
  flowSteps?: string
  includedItems?: string
  excludedItems?: string
  tags?: string
  visitFee?: number
  warrantyDays?: number
  /** 平均评分，C 端详情展示；0/空 为暂无评分 */
  ratingAvg?: number
  allowPickProvider?: boolean
  allowPickStore?: boolean
  providerScope?: 'CATEGORY' | 'WHITELIST'
  fulfillmentModes?: string
  orderImagesMode?: 'OFF' | 'OPTIONAL' | 'REQUIRED'
  orderImagesMin?: number
  orderImagesMax?: number
  orderImagesTip?: string
  customFieldSchema?: string
  orderImagesOverridden?: boolean
  customFieldsOverridden?: boolean
  allowGenderPref?: boolean
  serviceRadiusKm?: number
  dispatchSlaWarnMin?: number
  dispatchSlaExpandMin?: number
  dispatchSlaCancelMin?: number
  /** OFF / PLATFORM / CUSTOM */
  trustMode?: string
  /** CUSTOM 时勾选 ID JSON，如 "[1,2]" */
  trustItemIds?: string
  trustTip?: string
  /** 【历史兼容】绑定商城 SKU；解耦后可空，C 端不再依赖 */
  skuId?: number
  spuId?: number
  sort?: number
  /** C03 热门推荐 */
  homeHot?: boolean
  homeHotWeight?: number
  /** C03 猜你喜欢 */
  homeLike?: boolean
  homeLikeWeight?: number
  status?: string
  statusName?: string
  remark?: string
  createTime?: Date
  updateTime?: Date
}

export const CatalogServiceApi = {
  getPage: async (params: any) => {
    return await request.get({ url: '/o2o/catalog/service/page', params })
  },
  get: async (id: number) => {
    return await request.get({ url: '/o2o/catalog/service/get?id=' + id })
  },
  create: async (data: CatalogServiceVO) => {
    return await request.post({ url: '/o2o/catalog/service/create', data })
  },
  update: async (data: CatalogServiceVO) => {
    return await request.put({ url: '/o2o/catalog/service/update', data })
  },
  delete: async (id: number) => {
    return await request.delete({ url: '/o2o/catalog/service/delete?id=' + id })
  },
  publish: async (data: { id: number; publishMode: string; scheduledAt?: number }) => {
    return await request.post({ url: '/o2o/catalog/service/publish', data })
  },
  publishCheck: async (id: number, data: { publishMode: string; scheduledAt?: number }) => {
    return await request.post({ url: `/o2o/catalog/service/${id}/publish/check`, data })
  },
  unpublish: async (id: number) => {
    return await request.put({ url: '/o2o/catalog/service/unpublish?id=' + id })
  },
  preview: async (id: number, cityCode: string) => {
    return await request.get({
      url: '/o2o/catalog/service/preview',
      params: { id, cityCode }
    })
  },
  grayDownGlobal: async (id: number, data?: { reason?: string }) => {
    return await request.post({ url: `/o2o/catalog/service/${id}/gray-down/global`, data })
  },
  grayDownCity: async (id: number, data: { cityIds: number[]; reason?: string }) => {
    return await request.post({ url: `/o2o/catalog/service/${id}/gray-down/city`, data })
  },
  batchStatus: async (data: {
    serviceIds: number[]
    grayScope: string
    action: string
    cityIds?: number[]
  }) => {
    return await request.post({ url: '/o2o/catalog/service/batch-status', data })
  },
  getStores: async (id: number) => request.get({ url: `/o2o/catalog/service/${id}/stores` }),
  saveStores: async (id: number, storeIds: number[]) => request.put({
    url: `/o2o/catalog/service/${id}/stores`, data: { serviceId: id, storeIds }
  }),
  syncCategoryDefaults: async (categoryId: number) => request.post({
    url: '/o2o/catalog/service/sync-category-defaults', params: { categoryId }
  })
}
